const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('./search/search'));
    processInclude(require('autoship/product/quickView'));
});
